var cov_2jjqvnqdoy = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Progress/styles/index.js",
      hash = "58e2ebadf35e25c578d57da0964d5b38b48c536e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Progress/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 29
        },
        end: {
          line: 5,
          column: 65
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var progressLess = {};
import genaration from '../../utils/classname';
export var progressClass = (cov_2jjqvnqdoy.s[0]++, genaration(progressLess, 'progress'));